var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGender(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1701 4.67937C9.11634 4.67937 5.01946 8.77625 5.01946 13.83C5.01946 18.8838 9.11634 22.9806 14.1701 22.9806C19.2238 22.9806 23.3207 18.8838 23.3207 13.83C23.3207 8.77625 19.2238 4.67937 14.1701 4.67937ZM3.35571 13.83C3.35571 7.85739 8.19747 3.01562 14.1701 3.01562C20.1427 3.01562 24.9845 7.85739 24.9845 13.83C24.9845 19.8026 20.1427 24.6444 14.1701 24.6444C8.19747 24.6444 3.35571 19.8026 3.35571 13.83Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1702 9.67156C12.3325 9.67156 10.8427 11.1613 10.8427 12.9991C10.8427 14.8368 12.3325 16.3266 14.1702 16.3266C16.0079 16.3266 17.4977 14.8368 17.4977 12.9991C17.4977 11.1613 16.0079 9.67156 14.1702 9.67156ZM9.17896 12.9991C9.17896 10.2425 11.4136 8.00781 14.1702 8.00781C16.9268 8.00781 19.1615 10.2425 19.1615 12.9991C19.1615 15.7557 16.9268 17.9903 14.1702 17.9903C11.4136 17.9903 9.17896 15.7557 9.17896 12.9991Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1697 17.9919C12.9407 17.9919 11.7358 18.3322 10.6884 18.9751C9.64095 19.618 8.79202 20.5384 8.23567 21.6342C8.02769 22.0439 7.52699 22.2074 7.11733 21.9994C6.70767 21.7914 6.54418 21.2907 6.75216 20.881C7.4476 19.5112 8.50876 18.3608 9.81802 17.5571C11.1273 16.7535 12.6335 16.3281 14.1697 16.3281C15.7059 16.3281 17.2122 16.7535 18.5214 17.5571C19.8307 18.3608 20.8918 19.5112 21.5873 20.881C21.7952 21.2907 21.6318 21.7914 21.2221 21.9994C20.8124 22.2074 20.3117 22.0439 20.1038 21.6342C19.5474 20.5384 18.6985 19.618 17.6511 18.9751C16.6037 18.3322 15.3987 17.9919 14.1697 17.9919Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGender);
export default __webpack_public_path__ + "static/media/gender.d88790bf16fe357c8712078eb9234670.svg";
export { ForwardRef as ReactComponent };